var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 132,
    viewBox: "0 0 139 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 139,
    height: 132,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.2296 13.6562H49.0249V16.861H52.2296V13.6562Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5224 13.6562H55.3176V16.861H58.5224V13.6562Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8124 13.6562H61.6077V16.861H64.8124V13.6562Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.017 13.6562H64.8123V16.861H68.017V13.6562Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.307 13.6562H71.1023V16.861H74.307V13.6562Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5978 13.6562H77.3931V16.861H80.5978V13.6562Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0084 13.6562H83.8037V16.861H87.0084V13.6562Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3847 13.6562H93.1799V16.861H96.3847V13.6562Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8214 16.8613H42.6167V20.0661H45.8214V16.8613Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.026 16.8613H45.8213V20.0661H49.026V16.8613Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2296 16.8613H49.0249V20.0661H52.2296V16.8613Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3146 16.8613H52.1099V20.0661H55.3146V16.8613Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5224 16.8613H55.3176V20.0661H58.5224V16.8613Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7262 16.8613H58.5215V20.0661H61.7262V16.8613Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1024 16.8613H67.8977V20.0661H71.1024V16.8613Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5133 16.8613H74.3086V20.0661H77.5133V16.8613Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0084 16.8613H83.8037V20.0661H87.0084V16.8613Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0934 16.8613H86.8887V20.0661H90.0934V16.8613Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3847 16.8613H93.1799V20.0661H96.3847V16.8613Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8214 20.0654H42.6167V23.2702H45.8214V20.0654Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7262 20.0654H58.5215V23.2702H61.7262V20.0654Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M68.017 20.0654H64.8123V23.2702H68.017V20.0654Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1024 20.0654H67.8977V23.2702H71.1024V20.0654Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8039 20.0654H80.5991V23.2702H83.8039V20.0654Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0084 20.0654H83.8037V23.2702H87.0084V20.0654Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0934 20.0654H86.8887V23.2702H90.0934V20.0654Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8214 23.1523H42.6167V26.3571H45.8214V23.1523Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2296 23.1523H49.0249V26.3571H52.2296V23.1523Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3146 23.1523H52.1099V26.3571H55.3146V23.1523Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5224 23.1523H55.3176V26.3571H58.5224V23.1523Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5133 23.1523H74.3086V26.3571H77.5133V23.1523Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5978 23.1523H77.3931V26.3571H80.5978V23.1523Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8039 23.1523H80.5991V26.3571H83.8039V23.1523Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0934 23.1523H86.8887V26.3571H90.0934V23.1523Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8214 26.3574H42.6167V29.5622H45.8214V26.3574Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3146 26.3574H52.1099V29.5622H55.3146V26.3574Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5224 26.3574H55.3176V29.5622H58.5224V26.3574Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M68.017 26.3574H64.8123V29.5622H68.017V26.3574Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M74.307 26.3574H71.1023V29.5622H74.307V26.3574Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8039 26.3574H80.5991V29.5622H83.8039V26.3574Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0084 26.3574H83.8037V29.5622H87.0084V26.3574Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0934 26.3574H86.8887V29.5622H90.0934V26.3574Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M93.298 26.3574H90.0933V29.5622H93.298V26.3574Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8214 29.5615H42.6167V32.7663H45.8214V29.5615Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M49.026 29.5615H45.8213V32.7663H49.026V29.5615Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2296 29.5615H49.0249V32.7663H52.2296V29.5615Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8124 29.5615H61.6077V32.7663H64.8124V29.5615Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M68.017 29.5615H64.8123V32.7663H68.017V29.5615Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M74.307 29.5615H71.1023V32.7663H74.307V29.5615Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5133 29.5615H74.3086V32.7663H77.5133V29.5615Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0934 29.5615H86.8887V32.7663H90.0934V29.5615Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M93.298 29.5615H90.0933V32.7663H93.298V29.5615Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8214 32.6475H42.6167V35.8522H45.8214V32.6475Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2296 32.6475H49.0249V35.8522H52.2296V32.6475Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5224 32.6475H55.3176V35.8522H58.5224V32.6475Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8124 32.6475H61.6077V35.8522H64.8124V32.6475Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1024 32.6475H67.8977V35.8522H71.1024V32.6475Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5133 32.6475H74.3086V35.8522H77.5133V32.6475Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8039 32.6475H80.5991V35.8522H83.8039V32.6475Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0934 32.6475H86.8887V35.8522H90.0934V32.6475Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3847 32.6475H93.1799V35.8522H96.3847V32.6475Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M49.026 35.8516H45.8213V39.0563H49.026V35.8516Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2296 35.8516H49.0249V39.0563H52.2296V35.8516Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3146 35.8516H52.1099V39.0563H55.3146V35.8516Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5224 35.8516H55.3176V39.0563H58.5224V35.8516Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8124 35.8516H61.6077V39.0563H64.8124V35.8516Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M68.017 35.8516H64.8123V39.0563H68.017V35.8516Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1024 35.8516H67.8977V39.0563H71.1024V35.8516Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M74.307 35.8516H71.1023V39.0563H74.307V35.8516Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5978 35.8516H77.3931V39.0563H80.5978V35.8516Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M93.298 35.8516H90.0933V39.0563H93.298V35.8516Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3847 35.8516H93.1799V39.0563H96.3847V35.8516Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9496 38.9375H23.7449V42.1422H26.9496V38.9375Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M36.443 38.9375H33.2383V42.1422H36.443V38.9375Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5302 38.9375H36.3254V42.1422H39.5302V38.9375Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7348 38.9375H39.53V42.1422H42.7348V38.9375Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8214 38.9375H42.6167V42.1422H45.8214V38.9375Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M49.026 38.9375H45.8213V42.1422H49.026V38.9375Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5224 38.9375H55.3176V42.1422H58.5224V38.9375Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7262 38.9375H58.5215V42.1422H61.7262V38.9375Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5133 38.9375H74.3086V42.1422H77.5133V38.9375Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5978 38.9375H77.3931V42.1422H80.5978V38.9375Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0084 38.9375H83.8037V42.1422H87.0084V38.9375Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0934 38.9375H86.8887V42.1422H90.0934V38.9375Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5893 38.9375H96.3845V42.1422H99.5893V38.9375Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M105.881 38.9375H102.676V42.1422H105.881V38.9375Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M109.085 38.9375H105.88V42.1422H109.085V38.9375Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M112.289 38.9375H109.084V42.1422H112.289V38.9375Z",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M115.376 38.9375H112.171V42.1422H115.376V38.9375Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M118.58 38.9375H115.375V42.1422H118.58V38.9375Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7438 42.1436H20.5391V45.3483H23.7438V42.1436Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9496 42.1436H23.7449V45.3483H26.9496V42.1436Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0346 42.1436H26.8298V45.3483H30.0346V42.1436Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M36.443 42.1436H33.2383V45.3483H36.443V42.1436Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M49.026 42.1436H45.8213V45.3483H49.026V42.1436Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3146 42.1436H52.1099V45.3483H55.3146V42.1436Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5224 42.1436H55.3176V45.3483H58.5224V42.1436Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7262 42.1436H58.5215V45.3483H61.7262V42.1436Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8124 42.1436H61.6077V45.3483H64.8124V42.1436Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M68.017 42.1436H64.8123V45.3483H68.017V42.1436Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M74.307 42.1436H71.1023V45.3483H74.307V42.1436Z",
    fill: "black"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5978 42.1436H77.3931V45.3483H80.5978V42.1436Z",
    fill: "black"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8039 42.1436H80.5991V45.3483H83.8039V42.1436Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0934 42.1436H86.8887V45.3483H90.0934V42.1436Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M93.298 42.1436H90.0933V45.3483H93.298V42.1436Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3847 42.1436H93.1799V45.3483H96.3847V42.1436Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M105.881 42.1436H102.676V45.3483H105.881V42.1436Z",
    fill: "black"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M112.289 42.1436H109.084V45.3483H112.289V42.1436Z",
    fill: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M118.58 42.1436H115.375V45.3483H118.58V42.1436Z",
    fill: "black"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M121.666 42.1436H118.461V45.3483H121.666V42.1436Z",
    fill: "black"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5302 45.3477H36.3254V48.5524H39.5302V45.3477Z",
    fill: "black"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M49.026 45.3477H45.8213V48.5524H49.026V45.3477Z",
    fill: "black"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M102.793 45.3477H99.5886V48.5524H102.793V45.3477Z",
    fill: "black"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M112.289 45.3477H109.084V48.5524H112.289V45.3477Z",
    fill: "black"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M115.376 45.3477H112.171V48.5524H115.376V45.3477Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5392 48.4336H17.3345V51.6383H20.5392V48.4336Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7438 48.4336H20.5391V51.6383H23.7438V48.4336Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9496 48.4336H23.7449V51.6383H26.9496V48.4336Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0346 48.4336H26.8298V51.6383H30.0346V48.4336Z",
    fill: "black"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2384 48.4336H30.0337V51.6383H33.2384V48.4336Z",
    fill: "black"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7348 48.4336H39.53V51.6383H42.7348V48.4336Z",
    fill: "black"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3847 48.4336H93.1799V51.6383H96.3847V48.4336Z",
    fill: "black"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M102.793 48.4336H99.5886V51.6383H102.793V48.4336Z",
    fill: "black"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M105.881 48.4336H102.676V51.6383H105.881V48.4336Z",
    fill: "black"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M115.376 48.4336H112.171V51.6383H115.376V48.4336Z",
    fill: "black"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M121.666 48.4336H118.461V51.6383H121.666V48.4336Z",
    fill: "black"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2384 51.6387H30.0337V54.8434H33.2384V51.6387Z",
    fill: "black"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M36.443 51.6387H33.2383V54.8434H36.443V51.6387Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5302 51.6387H36.3254V54.8434H39.5302V51.6387Z",
    fill: "black"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7348 51.6387H39.53V54.8434H42.7348V51.6387Z",
    fill: "black"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M93.298 51.6387H90.0933V54.8434H93.298V51.6387Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3847 51.6387H93.1799V54.8434H96.3847V51.6387Z",
    fill: "black"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5893 51.6387H96.3845V54.8434H99.5893V51.6387Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M102.793 51.6387H99.5886V54.8434H102.793V51.6387Z",
    fill: "black"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M109.085 51.6387H105.88V54.8434H109.085V51.6387Z",
    fill: "black"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M112.289 51.6387H109.084V54.8434H112.289V51.6387Z",
    fill: "black"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M115.376 51.6387H112.171V54.8434H115.376V51.6387Z",
    fill: "black"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M118.58 51.6387H115.375V54.8434H118.58V51.6387Z",
    fill: "black"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M121.666 51.6387H118.461V54.8434H121.666V51.6387Z",
    fill: "black"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5392 54.8428H17.3345V58.0475H20.5392V54.8428Z",
    fill: "black"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7438 54.8428H20.5391V58.0475H23.7438V54.8428Z",
    fill: "black"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0346 54.8428H26.8298V58.0475H30.0346V54.8428Z",
    fill: "black"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2384 54.8428H30.0337V58.0475H33.2384V54.8428Z",
    fill: "black"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7348 54.8428H39.53V58.0475H42.7348V54.8428Z",
    fill: "black"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M93.298 54.8428H90.0933V58.0475H93.298V54.8428Z",
    fill: "black"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3847 54.8428H93.1799V58.0475H96.3847V54.8428Z",
    fill: "black"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5893 54.8428H96.3845V58.0475H99.5893V54.8428Z",
    fill: "black"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M102.793 54.8428H99.5886V58.0475H102.793V54.8428Z",
    fill: "black"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5392 57.9297H17.3345V61.1344H20.5392V57.9297Z",
    fill: "black"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9496 57.9297H23.7449V61.1344H26.9496V57.9297Z",
    fill: "black"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0346 57.9297H26.8298V61.1344H30.0346V57.9297Z",
    fill: "black"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2384 57.9297H30.0337V61.1344H33.2384V57.9297Z",
    fill: "black"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M36.443 57.9297H33.2383V61.1344H36.443V57.9297Z",
    fill: "black"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5302 57.9297H36.3254V61.1344H39.5302V57.9297Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7348 57.9297H39.53V61.1344H42.7348V57.9297Z",
    fill: "black"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3847 57.9297H93.1799V61.1344H96.3847V57.9297Z",
    fill: "black"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M102.793 57.9297H99.5886V61.1344H102.793V57.9297Z",
    fill: "black"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M109.085 57.9297H105.88V61.1344H109.085V57.9297Z",
    fill: "black"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M112.289 57.9297H109.084V61.1344H112.289V57.9297Z",
    fill: "black"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M115.376 57.9297H112.171V61.1344H115.376V57.9297Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M121.666 57.9297H118.461V61.1344H121.666V57.9297Z",
    fill: "black"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5392 61.1338H17.3345V64.3385H20.5392V61.1338Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0346 61.1338H26.8298V64.3385H30.0346V61.1338Z",
    fill: "black"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M93.298 61.1338H90.0933V64.3385H93.298V61.1338Z",
    fill: "black"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M102.793 61.1338H99.5886V64.3385H102.793V61.1338Z",
    fill: "black"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M121.666 61.1338H118.461V64.3385H121.666V61.1338Z",
    fill: "black"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0346 64.2197H26.8298V67.4245H30.0346V64.2197Z",
    fill: "black"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5302 64.2197H36.3254V67.4245H39.5302V64.2197Z",
    fill: "black"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M93.298 64.2197H90.0933V67.4245H93.298V64.2197Z",
    fill: "black"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3847 64.2197H93.1799V67.4245H96.3847V64.2197Z",
    fill: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5893 64.2197H96.3845V67.4245H99.5893V64.2197Z",
    fill: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M102.793 64.2197H99.5886V67.4245H102.793V64.2197Z",
    fill: "black"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M105.881 64.2197H102.676V67.4245H105.881V64.2197Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M109.085 64.2197H105.88V67.4245H109.085V64.2197Z",
    fill: "black"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M112.289 64.2197H109.084V67.4245H112.289V64.2197Z",
    fill: "black"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M115.376 64.2197H112.171V67.4245H115.376V64.2197Z",
    fill: "black"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M118.58 64.2197H115.375V67.4245H118.58V64.2197Z",
    fill: "black"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9496 67.4248H23.7449V70.6295H26.9496V67.4248Z",
    fill: "black"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0346 67.4248H26.8298V70.6295H30.0346V67.4248Z",
    fill: "black"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M36.443 67.4248H33.2383V70.6295H36.443V67.4248Z",
    fill: "black"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7348 67.4248H39.53V70.6295H42.7348V67.4248Z",
    fill: "black"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8214 67.4248H42.6167V70.6295H45.8214V67.4248Z",
    fill: "black"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5893 67.4248H96.3845V70.6295H99.5893V67.4248Z",
    fill: "black"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7438 70.6289H20.5391V73.8336H23.7438V70.6289Z",
    fill: "black"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9496 70.6289H23.7449V73.8336H26.9496V70.6289Z",
    fill: "black"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5302 70.6289H36.3254V73.8336H39.5302V70.6289Z",
    fill: "black"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7348 70.6289H39.53V73.8336H42.7348V70.6289Z",
    fill: "black"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M49.026 70.6289H45.8213V73.8336H49.026V70.6289Z",
    fill: "black"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M93.298 70.6289H90.0933V73.8336H93.298V70.6289Z",
    fill: "black"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M109.085 70.6289H105.88V73.8336H109.085V70.6289Z",
    fill: "black"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M115.376 70.6289H112.171V73.8336H115.376V70.6289Z",
    fill: "black"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M118.58 70.6289H115.375V73.8336H118.58V70.6289Z",
    fill: "black"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M121.666 70.6289H118.461V73.8336H121.666V70.6289Z",
    fill: "black"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9496 73.7148H23.7449V76.9196H26.9496V73.7148Z",
    fill: "black"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0346 73.7148H26.8298V76.9196H30.0346V73.7148Z",
    fill: "black"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M36.443 73.7148H33.2383V76.9196H36.443V73.7148Z",
    fill: "black"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8214 73.7148H42.6167V76.9196H45.8214V73.7148Z",
    fill: "black"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M49.026 73.7148H45.8213V76.9196H49.026V73.7148Z",
    fill: "black"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M93.298 73.7148H90.0933V76.9196H93.298V73.7148Z",
    fill: "black"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3847 73.7148H93.1799V76.9196H96.3847V73.7148Z",
    fill: "black"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M102.793 73.7148H99.5886V76.9196H102.793V73.7148Z",
    fill: "black"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M105.881 73.7148H102.676V76.9196H105.881V73.7148Z",
    fill: "black"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M115.376 73.7148H112.171V76.9196H115.376V73.7148Z",
    fill: "black"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M118.58 73.7148H115.375V76.9196H118.58V73.7148Z",
    fill: "black"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M121.666 73.7148H118.461V76.9196H121.666V73.7148Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5392 76.9199H17.3345V80.1247H20.5392V76.9199Z",
    fill: "black"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0346 76.9199H26.8298V80.1247H30.0346V76.9199Z",
    fill: "black"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M36.443 76.9199H33.2383V80.1247H36.443V76.9199Z",
    fill: "black"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5302 76.9199H36.3254V80.1247H39.5302V76.9199Z",
    fill: "black"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7348 76.9199H39.53V80.1247H42.7348V76.9199Z",
    fill: "black"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8214 76.9199H42.6167V80.1247H45.8214V76.9199Z",
    fill: "black"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M93.298 76.9199H90.0933V80.1247H93.298V76.9199Z",
    fill: "black"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M105.881 76.9199H102.676V80.1247H105.881V76.9199Z",
    fill: "black"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M115.376 76.9199H112.171V80.1247H115.376V76.9199Z",
    fill: "black"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M121.666 76.9199H118.461V80.1247H121.666V76.9199Z",
    fill: "black"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9496 80.125H23.7449V83.3297H26.9496V80.125Z",
    fill: "black"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0346 80.125H26.8298V83.3297H30.0346V80.125Z",
    fill: "black"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M36.443 80.125H33.2383V83.3297H36.443V80.125Z",
    fill: "black"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7348 80.125H39.53V83.3297H42.7348V80.125Z",
    fill: "black"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8214 80.125H42.6167V83.3297H45.8214V80.125Z",
    fill: "black"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M112.289 80.125H109.084V83.3297H112.289V80.125Z",
    fill: "black"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M118.58 80.125H115.375V83.3297H118.58V80.125Z",
    fill: "black"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M121.666 80.125H118.461V83.3297H121.666V80.125Z",
    fill: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5392 83.2109H17.3345V86.4157H20.5392V83.2109Z",
    fill: "black"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7438 83.2109H20.5391V86.4157H23.7438V83.2109Z",
    fill: "black"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9496 83.2109H23.7449V86.4157H26.9496V83.2109Z",
    fill: "black"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0346 83.2109H26.8298V86.4157H30.0346V83.2109Z",
    fill: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5302 83.2109H36.3254V86.4157H39.5302V83.2109Z",
    fill: "black"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8214 83.2109H42.6167V86.4157H45.8214V83.2109Z",
    fill: "black"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M49.026 83.2109H45.8213V86.4157H49.026V83.2109Z",
    fill: "black"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M93.298 83.2109H90.0933V86.4157H93.298V83.2109Z",
    fill: "black"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M102.793 83.2109H99.5886V86.4157H102.793V83.2109Z",
    fill: "black"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9496 86.415H23.7449V89.6198H26.9496V86.415Z",
    fill: "black"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0346 86.415H26.8298V89.6198H30.0346V86.415Z",
    fill: "black"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2384 86.415H30.0337V89.6198H33.2384V86.415Z",
    fill: "black"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M36.443 86.415H33.2383V89.6198H36.443V86.415Z",
    fill: "black"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7348 86.415H39.53V89.6198H42.7348V86.415Z",
    fill: "black"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3146 86.415H52.1099V89.6198H55.3146V86.415Z",
    fill: "black"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5224 86.415H55.3176V89.6198H58.5224V86.415Z",
    fill: "black"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7262 86.415H58.5215V89.6198H61.7262V86.415Z",
    fill: "black"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M68.017 86.415H64.8123V89.6198H68.017V86.415Z",
    fill: "black"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1024 86.415H67.8977V89.6198H71.1024V86.415Z",
    fill: "black"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M74.307 86.415H71.1023V89.6198H74.307V86.415Z",
    fill: "black"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5133 86.415H74.3086V89.6198H77.5133V86.415Z",
    fill: "black"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5978 86.415H77.3931V89.6198H80.5978V86.415Z",
    fill: "black"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0934 86.415H86.8887V89.6198H90.0934V86.415Z",
    fill: "black"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5893 86.415H96.3845V89.6198H99.5893V86.415Z",
    fill: "black"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M102.793 86.415H99.5886V89.6198H102.793V86.415Z",
    fill: "black"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M105.881 86.415H102.676V89.6198H105.881V86.415Z",
    fill: "black"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M121.666 86.415H118.461V89.6198H121.666V86.415Z",
    fill: "black"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5392 89.502H17.3345V92.7067H20.5392V89.502Z",
    fill: "black"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7438 89.502H20.5391V92.7067H23.7438V89.502Z",
    fill: "black"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9496 89.502H23.7449V92.7067H26.9496V89.502Z",
    fill: "black"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2384 89.502H30.0337V92.7067H33.2384V89.502Z",
    fill: "black"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5302 89.502H36.3254V92.7067H39.5302V89.502Z",
    fill: "black"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7348 89.502H39.53V92.7067H42.7348V89.502Z",
    fill: "black"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M49.026 89.502H45.8213V92.7067H49.026V89.502Z",
    fill: "black"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2296 89.502H49.0249V92.7067H52.2296V89.502Z",
    fill: "black"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3146 89.502H52.1099V92.7067H55.3146V89.502Z",
    fill: "black"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5224 89.502H55.3176V92.7067H58.5224V89.502Z",
    fill: "black"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8124 89.502H61.6077V92.7067H64.8124V89.502Z",
    fill: "black"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M68.017 89.502H64.8123V92.7067H68.017V89.502Z",
    fill: "black"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1024 89.502H67.8977V92.7067H71.1024V89.502Z",
    fill: "black"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5133 89.502H74.3086V92.7067H77.5133V89.502Z",
    fill: "black"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5978 89.502H77.3931V92.7067H80.5978V89.502Z",
    fill: "black"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0084 89.502H83.8037V92.7067H87.0084V89.502Z",
    fill: "black"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0934 89.502H86.8887V92.7067H90.0934V89.502Z",
    fill: "black"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M93.298 89.502H90.0933V92.7067H93.298V89.502Z",
    fill: "black"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3847 89.502H93.1799V92.7067H96.3847V89.502Z",
    fill: "black"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5893 89.502H96.3845V92.7067H99.5893V89.502Z",
    fill: "black"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M102.793 89.502H99.5886V92.7067H102.793V89.502Z",
    fill: "black"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M105.881 89.502H102.676V92.7067H105.881V89.502Z",
    fill: "black"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M109.085 89.502H105.88V92.7067H109.085V89.502Z",
    fill: "black"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M115.376 89.502H112.171V92.7067H115.376V89.502Z",
    fill: "black"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M118.58 89.502H115.375V92.7067H118.58V89.502Z",
    fill: "black"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M121.666 89.502H118.461V92.7067H121.666V89.502Z",
    fill: "black"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8214 92.7061H42.6167V95.9108H45.8214V92.7061Z",
    fill: "black"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5224 92.7061H55.3176V95.9108H58.5224V92.7061Z",
    fill: "black"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7262 92.7061H58.5215V95.9108H61.7262V92.7061Z",
    fill: "black"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1024 92.7061H67.8977V95.9108H71.1024V92.7061Z",
    fill: "black"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0084 92.7061H83.8037V95.9108H87.0084V92.7061Z",
    fill: "black"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M93.298 92.7061H90.0933V95.9108H93.298V92.7061Z",
    fill: "black"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3847 92.7061H93.1799V95.9108H96.3847V92.7061Z",
    fill: "black"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M109.085 92.7061H105.88V95.9108H109.085V92.7061Z",
    fill: "black"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M112.289 92.7061H109.084V95.9108H112.289V92.7061Z",
    fill: "black"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M118.58 92.7061H115.375V95.9108H118.58V92.7061Z",
    fill: "black"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M121.666 92.7061H118.461V95.9108H121.666V92.7061Z",
    fill: "black"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8214 95.9102H42.6167V99.1149H45.8214V95.9102Z",
    fill: "black"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2296 95.9102H49.0249V99.1149H52.2296V95.9102Z",
    fill: "black"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3146 95.9102H52.1099V99.1149H55.3146V95.9102Z",
    fill: "black"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5224 95.9102H55.3176V99.1149H58.5224V95.9102Z",
    fill: "black"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1024 95.9102H67.8977V99.1149H71.1024V95.9102Z",
    fill: "black"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5133 95.9102H74.3086V99.1149H77.5133V95.9102Z",
    fill: "black"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5978 95.9102H77.3931V99.1149H80.5978V95.9102Z",
    fill: "black"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M93.298 95.9102H90.0933V99.1149H93.298V95.9102Z",
    fill: "black"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3847 95.9102H93.1799V99.1149H96.3847V95.9102Z",
    fill: "black"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M102.793 95.9102H99.5886V99.1149H102.793V95.9102Z",
    fill: "black"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M109.085 95.9102H105.88V99.1149H109.085V95.9102Z",
    fill: "black"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M112.289 95.9102H109.084V99.1149H112.289V95.9102Z",
    fill: "black"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8214 98.998H42.6167V102.203H45.8214V98.998Z",
    fill: "black"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M49.026 98.998H45.8213V102.203H49.026V98.998Z",
    fill: "black"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2296 98.998H49.0249V102.203H52.2296V98.998Z",
    fill: "black"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5224 98.998H55.3176V102.203H58.5224V98.998Z",
    fill: "black"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7262 98.998H58.5215V102.203H61.7262V98.998Z",
    fill: "black"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8124 98.998H61.6077V102.203H64.8124V98.998Z",
    fill: "black"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1024 98.998H67.8977V102.203H71.1024V98.998Z",
    fill: "black"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M74.307 98.998H71.1023V102.203H74.307V98.998Z",
    fill: "black"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8039 98.998H80.5991V102.203H83.8039V98.998Z",
    fill: "black"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0084 98.998H83.8037V102.203H87.0084V98.998Z",
    fill: "black"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3847 98.998H93.1799V102.203H96.3847V98.998Z",
    fill: "black"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M109.085 98.998H105.88V102.203H109.085V98.998Z",
    fill: "black"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M115.376 98.998H112.171V102.203H115.376V98.998Z",
    fill: "black"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M121.666 98.998H118.461V102.203H121.666V98.998Z",
    fill: "black"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2296 102.202H49.0249V105.407H52.2296V102.202Z",
    fill: "black"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3146 102.202H52.1099V105.407H55.3146V102.202Z",
    fill: "black"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7262 102.202H58.5215V105.407H61.7262V102.202Z",
    fill: "black"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M68.017 102.202H64.8123V105.407H68.017V102.202Z",
    fill: "black"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1024 102.202H67.8977V105.407H71.1024V102.202Z",
    fill: "black"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5133 102.202H74.3086V105.407H77.5133V102.202Z",
    fill: "black"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0084 102.202H83.8037V105.407H87.0084V102.202Z",
    fill: "black"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3847 102.202H93.1799V105.407H96.3847V102.202Z",
    fill: "black"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5893 102.202H96.3845V105.407H99.5893V102.202Z",
    fill: "black"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M102.793 102.202H99.5886V105.407H102.793V102.202Z",
    fill: "black"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M105.881 102.202H102.676V105.407H105.881V102.202Z",
    fill: "black"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M109.085 102.202H105.88V105.407H109.085V102.202Z",
    fill: "black"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M115.376 102.202H112.171V105.407H115.376V102.202Z",
    fill: "black"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M118.58 102.202H115.375V105.407H118.58V102.202Z",
    fill: "black"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M121.666 102.202H118.461V105.407H121.666V102.202Z",
    fill: "black"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M49.026 105.406H45.8213V108.611H49.026V105.406Z",
    fill: "black"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5224 105.406H55.3176V108.611H58.5224V105.406Z",
    fill: "black"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8124 105.406H61.6077V108.611H64.8124V105.406Z",
    fill: "black"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M68.017 105.406H64.8123V108.611H68.017V105.406Z",
    fill: "black"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8039 105.406H80.5991V108.611H83.8039V105.406Z",
    fill: "black"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M93.298 105.406H90.0933V108.611H93.298V105.406Z",
    fill: "black"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3847 105.406H93.1799V108.611H96.3847V105.406Z",
    fill: "black"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5893 105.406H96.3845V108.611H99.5893V105.406Z",
    fill: "black"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M112.289 105.406H109.084V108.611H112.289V105.406Z",
    fill: "black"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M115.376 105.406H112.171V108.611H115.376V105.406Z",
    fill: "black"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M118.58 105.406H115.375V108.611H118.58V105.406Z",
    fill: "black"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8214 108.493H42.6167V111.698H45.8214V108.493Z",
    fill: "black"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M49.026 108.493H45.8213V111.698H49.026V108.493Z",
    fill: "black"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3146 108.493H52.1099V111.698H55.3146V108.493Z",
    fill: "black"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M68.017 108.493H64.8123V111.698H68.017V108.493Z",
    fill: "black"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M74.307 108.493H71.1023V111.698H74.307V108.493Z",
    fill: "black"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5133 108.493H74.3086V111.698H77.5133V108.493Z",
    fill: "black"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5978 108.493H77.3931V111.698H80.5978V108.493Z",
    fill: "black"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8039 108.493H80.5991V111.698H83.8039V108.493Z",
    fill: "black"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3847 108.493H93.1799V111.698H96.3847V108.493Z",
    fill: "black"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5893 108.493H96.3845V111.698H99.5893V108.493Z",
    fill: "black"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M102.793 108.493H99.5886V111.698H102.793V108.493Z",
    fill: "black"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M105.881 108.493H102.676V111.698H105.881V108.493Z",
    fill: "black"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M112.289 108.493H109.084V111.698H112.289V108.493Z",
    fill: "black"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M118.58 108.493H115.375V111.698H118.58V108.493Z",
    fill: "black"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M121.666 108.493H118.461V111.698H121.666V108.493Z",
    fill: "black"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M49.026 111.697H45.8213V114.902H49.026V111.697Z",
    fill: "black"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2296 111.697H49.0249V114.902H52.2296V111.697Z",
    fill: "black"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3146 111.697H52.1099V114.902H55.3146V111.697Z",
    fill: "black"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1024 111.697H67.8977V114.902H71.1024V111.697Z",
    fill: "black"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5133 111.697H74.3086V114.902H77.5133V111.697Z",
    fill: "black"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5978 111.697H77.3931V114.902H80.5978V111.697Z",
    fill: "black"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0084 111.697H83.8037V114.902H87.0084V111.697Z",
    fill: "black"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0934 111.697H86.8887V114.902H90.0934V111.697Z",
    fill: "black"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M93.298 111.697H90.0933V114.902H93.298V111.697Z",
    fill: "black"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3847 111.697H93.1799V114.902H96.3847V111.697Z",
    fill: "black"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5893 111.697H96.3845V114.902H99.5893V111.697Z",
    fill: "black"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M109.085 111.697H105.88V114.902H109.085V111.697Z",
    fill: "black"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M112.289 111.697H109.084V114.902H112.289V111.697Z",
    fill: "black"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M115.376 111.697H112.171V114.902H115.376V111.697Z",
    fill: "black"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M118.58 111.697H115.375V114.902H118.58V111.697Z",
    fill: "black"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M121.666 111.697H118.461V114.902H121.666V111.697Z",
    fill: "black"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2296 114.783H49.0249V117.988H52.2296V114.783Z",
    fill: "black"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7262 114.783H58.5215V117.988H61.7262V114.783Z",
    fill: "black"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M68.017 114.783H64.8123V117.988H68.017V114.783Z",
    fill: "black"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1024 114.783H67.8977V117.988H71.1024V114.783Z",
    fill: "black"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5893 114.783H96.3845V117.988H99.5893V114.783Z",
    fill: "black"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M109.085 114.783H105.88V117.988H109.085V114.783Z",
    fill: "black"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M112.289 114.783H109.084V117.988H112.289V114.783Z",
    fill: "black"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M115.376 114.783H112.171V117.988H115.376V114.783Z",
    fill: "black"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M121.666 114.783H118.461V117.988H121.666V114.783Z",
    fill: "black"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0466 13.6562C17.6906 13.6562 17.3345 14.0123 17.3345 14.3684V16.861V20.0657V23.1518V26.3565V29.5612V32.6473V35.1398C17.3345 35.4959 17.6906 35.852 18.0466 35.852H38.818C39.1741 35.852 39.5302 35.4959 39.5302 35.1398V32.6473V29.4425V26.2378V23.1518V19.947V16.861V14.3684C39.5302 14.0123 39.1741 13.6562 38.818 13.6562H18.0466ZM36.3255 20.0657V23.1518V26.3565V29.5612V32.2912C36.3255 32.5286 36.2068 32.6473 35.9694 32.6473H20.8953C20.6579 32.6473 20.5392 32.5286 20.5392 32.2912V29.5612V26.3565V23.1518V19.947V17.2171C20.5392 16.9797 20.6579 16.861 20.8953 16.861H35.9694C36.2068 16.861 36.3255 16.9797 36.3255 17.2171V20.0657Z",
    fill: "black"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2404 26.3558V23.151V20.6585C33.2404 20.3024 32.8843 19.9463 32.5283 19.9463H24.3384C23.9823 19.9463 23.6262 20.3024 23.6262 20.6585V23.151V26.3558V28.8483C23.6262 29.2044 23.9823 29.5605 24.3384 29.5605H32.5283C32.8843 29.5605 33.2404 29.2044 33.2404 28.8483V26.3558Z",
    fill: "black"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M100.182 13.6562C99.8256 13.6562 99.4695 14.0123 99.4695 14.3684V16.861V20.0657V23.1518V26.3565V29.5612V32.6473V35.1398C99.4695 35.4959 99.8256 35.852 100.182 35.852H120.953C121.309 35.852 121.665 35.4959 121.665 35.1398V32.6473V29.4425V26.2378V23.1518V19.947V16.861V14.3684C121.665 14.0123 121.309 13.6562 120.953 13.6562H100.182ZM118.46 20.0657V23.1518V26.3565V29.5612V32.2912C118.46 32.5286 118.342 32.6473 118.104 32.6473H103.149C102.912 32.6473 102.793 32.5286 102.793 32.2912V29.5612V26.3565V23.1518V19.947V17.2171C102.793 16.9797 102.912 16.861 103.149 16.861H118.223C118.46 16.861 118.579 16.9797 118.579 17.2171V20.0657H118.46Z",
    fill: "black"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M115.375 26.3558V23.151V20.6585C115.375 20.3024 115.019 19.9463 114.663 19.9463H106.473C106.117 19.9463 105.761 20.3024 105.761 20.6585V23.151V26.3558V28.8483C105.761 29.2044 106.117 29.5605 106.473 29.5605H114.663C115.019 29.5605 115.375 29.2044 115.375 28.8483V26.3558Z",
    fill: "black"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0466 95.9102C17.6906 95.9102 17.3345 96.2662 17.3345 96.6223V99.1149V102.32V105.524V108.729V111.934V115.139V117.631C17.3345 117.987 17.6906 118.343 18.0466 118.343H38.818C39.1741 118.343 39.5302 117.987 39.5302 117.631V115.139V111.934V108.729V105.524V102.32V99.1149V96.6223C39.5302 96.2662 39.1741 95.9102 38.818 95.9102H18.0466ZM36.3255 102.201V105.406V108.61V111.815V114.545C36.3255 114.782 36.2068 114.901 35.9694 114.901H20.8953C20.6579 114.901 20.5392 114.782 20.5392 114.545V111.815V108.61V105.406V102.201V99.471C20.5392 99.2336 20.6579 99.1149 20.8953 99.1149H35.9694C36.2068 99.1149 36.3255 99.2336 36.3255 99.471V102.201Z",
    fill: "black"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2404 108.492V105.288V102.795C33.2404 102.439 32.8843 102.083 32.5283 102.083H24.3384C23.9823 102.083 23.6262 102.439 23.6262 102.795V105.288V108.492V110.985C23.6262 111.341 23.9823 111.697 24.3384 111.697H32.5283C32.8843 111.697 33.2404 111.341 33.2404 110.985V108.492Z",
    fill: "black"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3467 48.5527H53.062V81.3122H85.3467V48.5527Z",
    fill: "white"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6227 76.8009C56.3853 78.2252 57.6909 79.2935 58.8779 78.5813L62.9135 76.2074C64.4565 75.3766 65.8808 74.9018 67.5425 74.9018H75.1389C77.3941 74.9018 79.4119 73.2401 79.768 70.9849L82.3792 56.3856C82.7353 54.4865 81.311 52.7061 79.2932 52.7061C74.4268 52.7061 69.5603 52.7061 64.6939 52.7061C62.4387 52.7061 60.4209 54.3678 60.0648 56.6229C58.9966 63.5072 57.8096 70.0353 56.6227 76.8009ZM75.8511 58.7594L76.0885 57.3351C76.2072 56.6229 76.9193 56.0295 77.6315 56.0295H79.4119L79.1745 57.4538C79.0558 58.166 78.4623 58.7594 77.6315 58.7594H75.8511ZM69.4416 59.4716C72.409 59.4716 73.8333 61.7268 73.2398 64.4567L72.1716 70.6288C72.0529 71.341 71.3407 71.9344 70.6286 71.9344H68.8481L70.0351 64.9315C70.2725 63.3885 69.679 62.4389 68.136 62.4389C66.4743 62.4389 65.2873 63.5072 65.0499 65.0502L63.863 71.5784C63.7443 72.0531 63.5069 72.4092 63.1508 72.6466L60.3022 74.1896L63.2695 57.3351C63.3882 56.6229 64.1004 56.0295 64.8126 56.0295H66.593L65.6434 61.1333C66.593 59.9464 67.8986 59.4716 69.4416 59.4716ZM73.4772 71.8158L75.3763 61.0146C75.495 60.3025 76.2072 59.709 76.9193 59.709H78.6997L76.8006 70.5101C76.6819 71.341 76.0885 71.8158 75.3763 71.8158H73.4772Z",
    fill: "#ED325D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.aef2ef3dd4dcb7003bdfe9c41aa5e86e.svg";
export { ForwardRef as ReactComponent };